export class TransportTariff {
  min_price: number = 0;
  min_hours: number = 1;
  after_mkad_km_price: number = 0;
  additional_hour_price: number = 0;
  ttk_price: number = 0;
  hydroelevator_hour_price: number = 0;
}
